export default __webpack_public_path__ + "static/PlayfairDisplay-BoldItalic-a7a7739180441c2c9623854ba8c140a8.woff2";